import '../brochure.css'

import { useWindowSize } from 'react-use'

import { Flex, Icon, Text } from '../../../Components'
import LogoSiapDark from '../../../Components/Common/images/siap_dark.png'
import LogoSiapLight from '../../../Components/Common/images/siap_light.png'

const WIDTH_DIMENSION = 1000

export default function FooterBrochure({ isDarkMode = false }) {
  const { width = 0 } = useWindowSize()
  const isMobile = width <= WIDTH_DIMENSION

  return (
    <div className={isMobile ? 'brochure-footer-wrapper-mobile' : 'brochure-footer-wrapper'}>
      {/* Sezione principale del footer */}
      <div className={isMobile ? 'brochure-footer-main-mobile' : 'brochure-footer-main'}>
        {/* Sezione NORA AI */}
        <div className="brochure-footer-section">
          <Text value="NORA AI" className="brochure-footer-section-title" />
          <Text
            value="L'intelligenza artificiale che rivoluziona i viaggi d'affari"
            className="brochure-footer-section-description"
          />
          <div className="brochure-footer-features">
            <Text value="• Automazione completa dei processi" className="brochure-footer-feature" />
            <Text value="• Risparmio del 25% sui costi" className="brochure-footer-feature" />
            <Text value="• Conformità automatica alle policy" className="brochure-footer-feature" />
          </div>
        </div>

        {/* Sezione contatti */}
        <div className="brochure-footer-section">
          <Text value="Contattaci" className="brochure-footer-section-title" />
          <div className="brochure-footer-contacts">
            <Flex row className="brochure-contact-item">
              <Icon name="phone" color="var(--primary)" style={{ marginRight: 12 }} />
              <a href="tel:+39 0172 652511" className="brochure-contact-link">
                <Text value="+39 0172 652511" className="brochure-contact-text" />
              </a>
            </Flex>

            <Flex row className="brochure-contact-item">
              <Icon name="mail" color="var(--primary)" style={{ marginRight: 12 }} />
              <a href="mailto:info@siapcn.it" className="brochure-contact-link">
                <Text value="info@siapcn.it" className="brochure-contact-text" />
              </a>
            </Flex>

            <Flex row className="brochure-contact-item">
              <Icon name="world" color="var(--primary)" style={{ marginRight: 12 }} />
              <a
                href="https://www.siapcn.it"
                target="_blank"
                rel="noopener noreferrer"
                className="brochure-contact-link"
              >
                <Text value="www.siapcn.it" className="brochure-contact-text" />
              </a>
            </Flex>
          </div>
        </div>

        {/* Sezione azienda */}
        <div className="brochure-footer-section">
          <div className="brochure-footer-company">
            <img
              src={isDarkMode ? LogoSiapLight : LogoSiapDark}
              alt="Logo SIAP"
              className="brochure-footer-logo"
            />
            <Text value="SIAP" className="brochure-footer-company-name" />
            <Text
              value="Soluzioni Intelligenti per l'Automazione dei Processi"
              className="brochure-footer-company-description"
            />
          </div>
        </div>
      </div>

      {/* Sezione copyright */}
      <div className="brochure-footer-bottom">
        <Flex row jsb ae style={{ width: '100%', flexWrap: 'wrap', gap: '16px' }}>
          <Text
            value="© 2025 SIAP. Tutti i diritti riservati."
            className="brochure-footer-copyright"
          />
        </Flex>
        {/*  <div className='brochure-footer-links'>
          <a href='#' className='brochure-footer-link'>Privacy Policy</a>
          <a href='#' className='brochure-footer-link'>Termini di Servizio</a>
          <a href='#' className='brochure-footer-link'>Cookie Policy</a>
        </div> */}
      </div>
    </div>
  )
}
